// extracted by mini-css-extract-plugin
module.exports = {"root":"LearnMoreTitle_root__33QpZ","pageTitle":"LearnMoreTitle_pageTitle__1VnXs"};